export const radio = {
  border: '2px solid',
  borderColor: 'grey/light/background',
  borderRadius: 'round',
  width: 'xs',
  height: 'xs',
  position: 'relative',
  states: {
    '&:after': {
      content: "''",
      position: 'absolute',
      display: 'none',
    },
  },
  textStyle: {
    paddingLeft: 5,
    paddingRight: 5,
    mb: 0,
  },
  variants: {
    checked: {
      border: '2px solid',
      borderColor: 'primary',
      background: 'transparent',
      states: {
        '&:after': {
          display: 'block',
          borderRadius: 'round',
          bg: 'primary',
          width: '8px',
          height: '8px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        },
      },
    },
    disabled: {
      bg: 'grey/light',
      pointerEvents: 'none',
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },
};
